/**
 * Shared motion primitives (framer-motion variants + timing).
 *
 * Subtle, professional motion: short fade-up on mount and a light stagger for
 * lists/grids. Gate every use behind `usePrefersMotion()` so it fully disables
 * for reduced-motion users and when the `animationsEnabled` preference is off.
 */

import type { Variants } from 'framer-motion';

/** Gentle ease-out (cubic-bezier) used across the app. */
export const EASE_OUT = [0.22, 1, 0.36, 1] as const;

export const DURATION = { fast: 0.18, base: 0.28, slow: 0.4 } as const;

/** Fade + small rise, for page mounts and standalone blocks. */
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.base, ease: EASE_OUT },
  },
};

/** Parent of a staggered group (lists, card grids, settings sections). */
export const staggerContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.05, delayChildren: 0.02 } },
};

/** Child of `staggerContainer`. */
export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.base, ease: EASE_OUT },
  },
};
